import React from 'react'

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger'

const toneStyles: Record<StatusTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
  info: 'bg-brand-50 text-brand-800 ring-brand-200',
  success: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  warning: 'bg-amber-50 text-amber-900 ring-amber-200',
  danger: 'bg-rose-50 text-rose-800 ring-rose-200',
}

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone
}

export function StatusPill({
  tone = 'neutral',
  className = '',
  children,
  ...props
}: StatusPillProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${toneStyles[tone]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}
